module.exports = "<toaster-container  [toasterconfig]=\"config\"></toaster-container>\n<router-outlet></router-outlet>\n<span defaultOverlayTarget></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main